module.exports = __webpack_public_path__ + "static/media/novena_aguinaldo.82cdb34c.svg";